/* 
 * Google Material Web (m3) 
 * @material/web
*/

// Checkbox
import '@material/web/checkbox/checkbox.js';
import '@material/web/checkbox/harness.js';

// Chips
import '@material/web/chips/filter-chip.js';

// Select
import '@material/web/select/filled-select.js';
import '@material/web/select/outlined-select.js';
import '@material/web/select/select-option.js';

// Algolia Events Filter
import './algolia-events-filter.js';

// Event Load More Pagination
import './event-load-more.js';

// Swiper.js - Product Carousel (CSS imported in SCSS)
import './swiper-init.js';
import './product-lightbox.js';

// Sticky Effect - Functionally Scoped
function applyStickyEffect() {
    const stickyDiv = document.querySelector('.is-position-sticky');
    if (!stickyDiv) return; // Exit if element doesn't exist

    const stickyOffset = stickyDiv.offsetTop;

    document.addEventListener('scroll', () => {
        if (window.scrollY >= stickyOffset) {
            stickyDiv.classList.add('is-fixed');
        } else {
            stickyDiv.classList.remove('is-fixed');
        }
    });
}
// Initialize Sticky Effect on DOMContentLoaded
document.addEventListener('DOMContentLoaded', applyStickyEffect);

// Smooth Scroll Function for Anchor Tags
function smoothScroll() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]'); // Select all anchor links with href starting with #

    if (!anchorLinks.length) return; // Exit if no anchor links found

    anchorLinks.forEach(anchor => {
        anchor.addEventListener('click', function(event) {
            const href = this.getAttribute('href');

            // Skip empty or just "#" anchors
            if (!href || href === '#') return;

            // Skip WordPress navigation elements
            if (this.closest('.wp-block-navigation')) return;

            // Only proceed if target element exists
            const targetId = href.substring(1); // Get target ID without the #
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                event.preventDefault(); // Prevent default jump to anchor
                // Smooth scroll to the element's position
                window.scrollTo({
                    top: targetElement.offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
}
// Initialize smooth scroll on page load
document.addEventListener('DOMContentLoaded', smoothScroll);

// Scroll Animate
document.addEventListener("DOMContentLoaded", function () {
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
        console.warn('IntersectionObserver not supported - scroll animations disabled');
        return;
    }

    const observerOptions = {
        root: null, // Viewport as root
        rootMargin: '0px',
        threshold: 0.1 // 10% of the element must be visible to trigger
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Find any class starting with `__` to identify animation type
                const animationClass = Array.from(entry.target.classList).find(cls => cls.startsWith('__'));

                if (animationClass) {
                    // Add animate.css base class and the specific animation class
                    entry.target.classList.add('animate__animated', `animate${animationClass}`);
                    entry.target.style.opacity = '1'; // Make element visible
                }
                observer.unobserve(entry.target); // Stop observing to prevent re-animation
            }
        });
    }, observerOptions);

    // Function to observe elements (for both initial and dynamically added elements)
    const observeElements = () => {
        const scrollElements = document.querySelectorAll('.scroll-animate:not(.animate__animated)');
        if (!scrollElements.length) return; // Exit if no elements found

        scrollElements.forEach(element => {
            observer.observe(element);
        });
    };

    // Observe initially existing elements
    observeElements();

    // Re-observe dynamically added elements using MutationObserver
    const domObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.classList && node.classList.contains('scroll-animate')) {
                    observer.observe(node);
                }
            });
        });
    });

    // Start observing the document for changes
    domObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
});

// Add SVG Path for WP Submenus 
(function () {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const PATH_D = 'M1.50002 4L6.00002 8L10.5 4';

  function patchToggle(btn) {
    if (!btn || btn.__patchedArrow) return;
    let svg = btn.querySelector('svg');
    if (!svg) {
      svg = document.createElementNS(SVG_NS, 'svg');
      // size matches common WP nav icon defaults; adjust if needed
      svg.setAttribute('viewBox', '0 0 12 12');
      svg.setAttribute('aria-hidden', 'true');
      btn.appendChild(svg);
    }
    // avoid duplicates
    if (!svg.querySelector(`path[d="${PATH_D}"]`)) {
      const path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', PATH_D);
      path.setAttribute('stroke-width', '1.5');
      svg.appendChild(path);
    }
    btn.__patchedArrow = true;
  }

  function patchAll(root = document) {
    const buttons = root.querySelectorAll(
      'ul.wp-block-navigation__container li.wp-block-navigation-item button.wp-block-navigation__submenu-icon.wp-block-navigation-submenu__toggle'
    );
    buttons.forEach(patchToggle);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => patchAll());
  } else {
    patchAll();
  }

  // Watch for dynamically added nav items
  const obs = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('button.wp-block-navigation__submenu-icon.wp-block-navigation-submenu__toggle')) {
          patchToggle(node);
        }
        patchAll(node);
      });
    });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();